import { render, staticRenderFns } from "./TablePhase.vue?vue&type=template&id=17b76a24&scoped=true"
import script from "./TablePhase.vue?vue&type=script&lang=js"
export * from "./TablePhase.vue?vue&type=script&lang=js"
import style0 from "./TablePhase.vue?vue&type=style&index=0&id=17b76a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b76a24",
  null
  
)

export default component.exports